<!--
 * @Description:
 * @Author: 诺
 * @Date: 2021-12-19 14:19:13
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-20 09:26:08
-->
<template>
      <div class="btn" @click="upSdkInit">更新sdk使用的appid</div>
</template>

<script>


export default {
  components: {
  },
  props: {},
  data() {
    return {
    };
  },

  filters: {
  },
  created() {},
  mounted() {
  },
  methods: {
    upSdkInit(){
      const  shareLink = `${this.$site}#/index?fopenid=${this.$openid}&actCode=${this.$actCode}`;
          this.$wx.upShare('shareTitle', 'shareInfo', shareLink, 'shareSmallImg');
      if(this.$route.query.testShareAppid){
        this.$wx.isNeedUpdate(this.$route.query.testShareAppid)
      }else{
        this.$showToast("缺少参数", "提示");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn{
  width:375px;
  height:200px;
  background: aliceblue;
  text-align: center;
  line-height: 200px;
}
</style>
